import { Room } from 'livekit-client';
import { useTranslation } from 'react-i18next';
import { Button, Loader } from '@spotted-zebra-uk/ui-components';
import { ConferenceRoom } from '../ConferenceRoom/ConferenceRoom';
import { ConferenceRoomWithAvatars } from '../ConferenceRoomWithAvatars/ConferenceRoomWithAvatars';
import { SessionMonitoredBadge } from '../SessionMonitoredBadge/SessionMonitoredBadge';
import { useShowInterviewMonitoringUi } from '../hooks/useShowInterviewMonitoringUi';
import styles from './ConferenceLobby.module.scss';

export type EndCallConfig = {
  title: string;
  message: string;
  confirmLabel: string;
};

type ConferenceLobbyProps = {
  room: Room | null;
  isConnected: boolean;
  error: Error | null;
  onEndInterview: () => void;
  useAvatar?: boolean;
  endCallConfig?: EndCallConfig;
};

export function ConferenceLobby({
  room,
  isConnected,
  error,
  onEndInterview,
  useAvatar = true,
  endCallConfig,
}: ConferenceLobbyProps) {
  const { t } = useTranslation();
  const showMonitoringUi = useShowInterviewMonitoringUi();

  if (error && !isConnected) {
    return (
      <div className={styles.errorContainer}>
        <div className={styles.errorCard}>
          <h1 className={styles.errorTitle}>{t('aiInterview.connectionError')}</h1>
          <p className={styles.errorMessage}>{error.message}</p>
          <Button
            onClick={() => window.location.reload()}
            className={styles.retryButton}
          >
            {t('aiInterview.tryAgain')}
          </Button>
        </div>
      </div>
    );
  }

  if (isConnected && room) {
    if (useAvatar) {
      return (
        <>
          {showMonitoringUi && (
            <div className={styles.sessionMonitoredContainer}>
              <SessionMonitoredBadge />
            </div>
          )}
          <ConferenceRoomWithAvatars
            room={room}
            onEndCall={onEndInterview}
            endCallConfig={endCallConfig}
          />
        </>
      );
    }

    return (
      <>
        {showMonitoringUi && (
          <div className={styles.sessionMonitoredContainer}>
            <SessionMonitoredBadge />
          </div>
        )}
        <ConferenceRoom
          room={room}
          onEndCall={onEndInterview}
          endCallConfig={endCallConfig}
        />
      </>
    );
  }

  return (
    <section className={styles.loaderContainer}>
      <Loader variant="bubbles" />
    </section>
  );
}
